export const courseMakerOrigin =
  import.meta.env.VITE_API_BASE_URL ?? import.meta.env.VITE_COURSEMAKER_ORIGIN ?? "";

// Use relative path in development to enable Vite proxy, otherwise use full URL
const coursemakerBaseURL = import.meta.env.DEV
  ? "/api"
  : courseMakerOrigin
    ? `${courseMakerOrigin}/api`
    : "https://coursemaker.vixiapp.com/api";

export const api_urls = {
  coursemaker: coursemakerBaseURL,
};

export default api_urls;
